var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"ui negative message"},[_c('i',{staticClass:"close icon",on:{"click":_vm.hide}}),_vm._v(" "),_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.message))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b3aced","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = eAn8
// module chunks = 10